import type { Deck, Slide } from "@hali-shares/deck-schema";

/** Milliseconds spent per section; "" collects time on the title slide (no budget). */
export type Times = Record<string, number>;
export type ClockState = { times: Times; running: boolean; started: boolean };

export const EMPTY: ClockState = { times: {}, running: false, started: false };

export function sectionOf(slide: Slide | undefined): string {
  return slide && slide.kind !== "title" ? slide.sectionId : "";
}

/** Add elapsed time to the section on screen. */
export function tick(state: ClockState, sectionId: string, ms: number): ClockState {
  if (!state.running || ms <= 0) return state;
  return { ...state, times: { ...state.times, [sectionId]: (state.times[sectionId] ?? 0) + ms } };
}

export function total(times: Times): number {
  return Object.values(times).reduce((a, b) => a + b, 0);
}

export function budgetMs(deck: Deck, sectionId: string): number | null {
  const s = deck.sections.find((x) => x.id === sectionId);
  return s ? s.minutes * 60_000 : null;
}

export function totalBudgetMs(deck: Deck): number {
  return deck.sections.reduce((n, s) => n + s.minutes, 0) * 60_000;
}

/** 3:07, 12:40, 1:02:05. */
export function fmt(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = String(s % 60).padStart(2, "0");
  return h ? `${h}:${String(m).padStart(2, "0")}:${ss}` : `${m}:${ss}`;
}
